import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { selectCurrentUser } from "../Users/usersSlice";
import { useNavigate } from "react-router-dom";
import {
  InvitationNetworkErrors,
  InvitationNotifications,
  useUserInvitationsByProgramIds
} from "./userInvitationUtils";
import { DataGridErrorOverlay } from "../../common-ui/DataGridErrorOverlay";
import { getProgramMembershipsAsProgramAdmin } from "../../app/utils";
import Grid from "@mui/material/Unstable_Grid2";

export const ProgramAdminsUserInvitationsTable = ({
  disableVirtualization = false,
  columns
}: {
  disableVirtualization?: boolean;
  columns: GridColDef[];
}) => {
  const { t } = useTranslation();
  const currentUser = useAppSelector(selectCurrentUser);
  const navigate = useNavigate();

  const { programMembershipsAsProgramAdmin } = getProgramMembershipsAsProgramAdmin(currentUser);
  const programIds = programMembershipsAsProgramAdmin?.map(pm => pm!.programId);

  const { userInvitations, status, error } =
    useUserInvitationsByProgramIds(programIds);

  return (
    <Grid
      sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
    >
      {(status === "failed" || error) && (
        <DataGridErrorOverlay
          errorMessage={InvitationNetworkErrors.FetchAllInvitationsError}
        />
      )}
      <Grid xs={12} sx={{ flex: 1, minHeight: 0, display: "flex" }}>
        <DataGrid
          disableVirtualization={disableVirtualization}
          aria-label="user-invitations-table-programadmins"
          rows={userInvitations || []}
          columns={columns}
          loading={[status].includes("loading")}
          localeText={{
            noRowsLabel: t(InvitationNotifications.NoInvitations)
          }}
          onRowClick={(rowData) => {
            const { row } = rowData;
            const { id } = row;
            if (id) {
              navigate(`${id}`);
            }
          }}
          sx={{
            flex: 1,
            minHeight: 0
          }}
        />
      </Grid>
    </Grid>
  );
};
